import { useQuery } from "@tanstack/react-query";
import { CountryCode, StopId } from "@vygruppen/vy-train-map";
import { getBackendUrl } from "api/common";
import { queryFnGET } from "api/tanStackQuery/helpers";

export type ExistingCancelledTrainRouteResponse = {
  uuid: string;
  stops: Stop[];
};

export type Stop = {
  ids: Array<StopId>;
};

type Props = {
  countryCode: CountryCode | undefined;
  trainId: string | undefined;
  nominalDate: string | undefined;
  uuid: string | undefined;
};

const routeChangedEventsQueryKey = (
  eventUuid: string | undefined,
  countryCode: CountryCode | undefined,
  trainId: string | undefined,
  nominalDate: string | undefined,
) => [
  "existingCancelledTrainEvents",
  eventUuid,
  countryCode,
  trainId,
  nominalDate,
];

export const useExistingTrainCancelledEvents = ({
  countryCode,
  trainId,
  nominalDate,
  uuid,
}: Props) => {
  const { status, data, isSuccess } = useQuery({
    queryKey: routeChangedEventsQueryKey(
      uuid,
      countryCode,
      trainId,
      nominalDate,
    ),
    queryFn: ({ signal }) =>
      queryFnGET<ExistingCancelledTrainRouteResponse[]>({
        signal,
        url: `${getBackendUrl()}/trainInformation/train/existing/cancelled-stops/${countryCode}/${trainId}/${nominalDate}`,
      }),
    gcTime: 0,
  });
  return { status, data, isSuccess };
};
